import { routerNonUiEventBus } from './RouterNonUiEventBus';
import { BillingAppRouterService } from './services/BillingAppRouterService';
import { MyAccountRouterService } from './services/MyAccountRouterService';
import type { Flags, Router } from './types';
import { WithApi } from '../WithApi';

type TApi = ReturnType<MyAccountRouterService['api']> & ReturnType<BillingAppRouterService['api']>;

export class RouterNonUiManager extends WithApi<TApi> {
  public routerNonUiInit = ({ history, params }: Router, flags: Flags) => {
    const currentPathname = history.location.pathname;

    if (history.action === 'POP') {
      // react to user navigating via browser back/forward buttons
      routerNonUiEventBus.emit('routePopped', currentPathname, { source: 'user' });
    }

    const myAccountApp = new MyAccountRouterService({ history, params }, flags);
    const billingApp = new BillingAppRouterService({ history, params });

    this.initApi({
      ...myAccountApp.api(),
      ...billingApp.api(),
    });
  };
}
